import { configureStore } from '@reduxjs/toolkit';
import reservationReducer from "./feature/reservation/slice";
import invoiceReducer from "./feature/invoice/slice";

const store = configureStore({
    reducer: {
      reservation: reservationReducer,
      invoice: invoiceReducer,
    },
  });
  
  export default store;